import { SHIPPERS } from '../constants/contactCategory'

// todo add merchants, truck sales dealers, finance dealers... when implemented
const useContactUrl = () => {
  const getUrl = (contact) => {
    const { id, contactCategory } = contact
    if (contactCategory && id) {
      if (contactCategory === SHIPPERS) {
        return `/customer-logistics/all-customers/${id}`
      } else {
        return `/contacts/${id}`
      }
    } else {
      return '/'
    }
  }

  return { getUrl }
}

export default useContactUrl
